
import { Button } from "@/components/ui/button";

interface CalendarDayProps {
  day: number;
  isSelected: boolean;
  isDisabled: boolean;
  onSelect: (day: number) => void;
}

const CalendarDay = ({ day, isSelected, isDisabled, onSelect }: CalendarDayProps) => {
  return (
    <Button
      variant="ghost"
      className={`h-8 w-full p-0 text-sm transition-colors
        ${isSelected ? 'bg-primary text-primary-foreground hover:bg-primary/90' : ''}
        ${isDisabled ? 'opacity-50 cursor-not-allowed' : 'hover:bg-primary/10'}
      `}
      onClick={() => {
        if (!isDisabled) {
          onSelect(day);
        }
      }}
      disabled={isDisabled}
      aria-label={`Select day ${day}`}
      aria-selected={isSelected}
    >
      {day}
    </Button>
  );
};

export default CalendarDay;
